var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "div",
        { staticClass: "parlay-builder" },
        _vm._l(_vm.marketSubTypesData, function(marketSubType) {
          return _c(
            "v-expansion-panel",
            {
              key: marketSubType.name,
              staticClass: "market-type-class",
              class: marketSubType.name
            },
            [
              _c(
                "v-expansion-panel-content",
                [
                  _c("h3", { attrs: { slot: "header" }, slot: "header" }, [
                    _vm._v(_vm._s(marketSubType.name) + " - "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("Parlay.Builder")))])
                  ]),
                  _vm._v(" "),
                  _vm._l(marketSubType.marketsByEvent, function(event) {
                    return _c(
                      "div",
                      {
                        key: event.eventData.idfoevent.toString(),
                        staticClass: "event"
                      },
                      [
                        _c("h3", [_vm._v(_vm._s(event.eventData.eventname))]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "eventmarketgroup marketgroup" },
                          [
                            _c("markets", {
                              attrs: {
                                markets: [event.market],
                                event: event.eventData,
                                diplayOnPage: "live-single-event",
                                isbig3coupon: false
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f661b14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f661b14","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/ParlayBuilder.vue
// module id = null
// module chunks = 